<dm-grid-filter-dropdown
  class="view-area-holder"
  [typeControl]="typeControl"
  [filterTypes]="filterOptions"
  [searchControl]="suppressSearchControl ? null : filterControl"
  (resetClick)="resetBtnClick()"
  (applyClick)="applyClick()"
  [i18n]="staticTextContent.dmGridFilterDropdown"
>
  <div *ngIf="noVisibleItems; else elseBlock" class="view-area">
    <p>{{ staticTextContent.noItems | translate }}</p>
  </div>

  <ng-template #elseBlock>
    <div class="view-area dropdown-filter-control-line input-padding" *ngIf="!suppressSelectAllControl && !isEqualMode">
      <div class="xux-checkbox">
        <input type="checkbox" #selectAllCheckbox [id]="'selectAll'" (change)="selectAllClick()" />
        <label [for]="'selectAll'" [class.indeterminate]="isPartialSelect">
          <span>{{ staticTextContent.selectAll | translate }}</span>
        </label>
      </div>
    </div>
    <div class="view-area scroll-area">
      <div
        *ngFor="let item of items; let index = index; trackBy: trackByValue"
        class="xux-checkbox"
        [class.hidden]="item.hidden"
      >
        <input
          type="checkbox"
          #itemCheckbox
          [id]="item.value"
          [value]="item.value"
          [checked]="item.checked"
          (change)="checkboxClicked(index)"
        />
        <label [for]="item.value">
          <span>{{ item.text | translate }}</span>
        </label>
      </div>
    </div>
  </ng-template>
</dm-grid-filter-dropdown>
